import { render, staticRenderFns } from "./audiogolawer.vue?vue&type=template&id=21cfa814&scoped=true&"
import script from "./audiogolawer.vue?vue&type=script&lang=js&"
export * from "./audiogolawer.vue?vue&type=script&lang=js&"
import style0 from "./audiogolawer.vue?vue&type=style&index=0&id=21cfa814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cfa814",
  null
  
)

export default component.exports